import { MeiliSearch } from 'meilisearch'

const MEILI_HOST = import.meta.env.VITE_MEILI_HOST || 'http://localhost:7700'
const MEILI_KEY = import.meta.env.VITE_MEILI_SEARCH_KEY || ''

export const meili = new MeiliSearch({
  host: MEILI_HOST,
  apiKey: MEILI_KEY,
})

export async function searchCourses(
  query: string,
  options?: {
    filter?: string
    sort?: string[]
    limit?: number
    offset?: number
  },
) {
  const index = meili.index('courses')
  return index.search(query, {
    ...options,
    attributesToHighlight: ['title', 'description'],
    highlightPreTag: '<mark>',
    highlightPostTag: '</mark>',
  })
}

export async function searchPrompts(
  query: string,
  options?: {
    filter?: string
    sort?: string[]
    limit?: number
    offset?: number
    facets?: string[]
  },
) {
  const index = meili.index('prompts')
  return index.search(query, {
    ...options,
    attributesToHighlight: ['title', 'description'],
    highlightPreTag: '<mark>',
    highlightPostTag: '</mark>',
    facets: options?.facets || ['category', 'aiModel', 'tags'],
  })
}
